import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpacierArcadeGameAssets} from "../../SpacierArcadeGameAssets";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {
    StandardAutoCloseGameModeTransitionView
} from "@nolimitcity/slot-game/bin/timelinegameround/game/screen/StandardAutoCloseGameModeTransitionView";
import {SAFreespinEvent} from "../../background/SABackground";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {SpacierArcadeSoundConfig} from "../../SpacierArcadeSoundConfig";

export class AAFreespinIntroView extends StandardAutoCloseGameModeTransitionView {
    protected BUTTON_SIZE:PIXI.Point = new PIXI.Point(180, 48);
    protected BUTTON_TEXT_STYLE:PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily : "Open Sans",
        fontStyle : FontStyle.ITALIC,
        fontSize : 24,
        fill : "#ffffff",
        fontWeight : FontWeight.EXTRA_BOLD
    });
    private _scatterTriggerSpine:PIXI.spine.Spine;
    private _timeline:TimelineLite;
    private _innerGraphicsContainer:PIXI.Container;
    private _restSymbolCallback:() => void;
    private _totalWinText:PIXI.Text;
    private _tempStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : 25,
        fontWeight : FontWeight.BOLD,
        align : "center",
        fill : [
            "#ffffff"
        ]
    };

    constructor(layer:ScalableLayer, autoCloseTimerDuration:number = 2000000) {
        super(layer, autoCloseTimerDuration);
    }

    protected createBackground(): PIXI.DisplayObject {
        return new PIXI.Container();
    }

    public prepare(data: ParsedServerData): void{
        if( data.freespinsLeft > 0) {
            EventHandler.dispatchEvent(new GameEvent(SAFreespinEvent.UPDATE_FREE_SPIN_COUNT, data.freespinsLeft));
            this._totalWinText.text = Translation.translate(data.freespinsLeft.toString() + " SPINS");
        }
    }


    protected createGameGraphics():PIXI.DisplayObject {
        const container: PIXI.Container = new PIXI.Container();

        this._scatterTriggerSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(SpacierArcadeGameAssets.FG_EFFECTS));
        // this._scatterTriggerSpine.piv
        this._scatterTriggerSpine.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5 + GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_HEIGHT * 0.53 +  GameConfig.instance.REEL_AREA_POS_Y);
        this._scatterTriggerSpine.autoUpdate = true;


        this._innerGraphicsContainer = new PIXI.Container();
        const fsIntroHole:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("fs_intro_blackhole")[0]);
        fsIntroHole.anchor.set(0.5);
        fsIntroHole.position.set(5, -35);
        this._innerGraphicsContainer.addChild(fsIntroHole);

        const fsIntroInfo:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("fs_reel_blue")[0]);
        fsIntroInfo.anchor.set(0.5);
        fsIntroInfo.position.set(0, -40);
        fsIntroInfo.blendMode = PIXI.BLEND_MODES.ADD;
        this._innerGraphicsContainer.addChild(fsIntroInfo);

        let fixedText:PIXI.Text = new PIXI.Text(Translation.translate("5x5"), this._tempStyle);
        fixedText.anchor.set(0.5);
        fixedText.position.set(0, -220);
        fixedText.style.fontSize = 45;
        this._innerGraphicsContainer.addChild(fixedText);

        let stickyText:PIXI.Text = new PIXI.Text(Translation.translate("GUARANTEED WILDS"), this._tempStyle);
        stickyText.anchor.set(0.5);
        stickyText.position.set(0, -170);
        this._innerGraphicsContainer.addChild(stickyText);

        const fusionSpin:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("fusion_spin")[0]);
        fusionSpin.anchor.set(0.5);
        fusionSpin.position.set(0, -60);
        this._innerGraphicsContainer.addChild(fusionSpin);

        this._totalWinText = new PIXI.Text("SPINS", this._tempStyle);
        this._totalWinText.anchor.set(0.5);
        this._totalWinText.position.set(0, 50);
        this._innerGraphicsContainer.addChild(this._totalWinText);

        this._innerGraphicsContainer.visible = false;
        container.addChild(this._innerGraphicsContainer);
        container.addChild(this._scatterTriggerSpine);
        return container;
    }

    public playScatterTrigger():TimelineLite{
        let animTimeLine:TimelineLite = new TimelineLite();
        animTimeLine.add([new SpineTween(this._scatterTriggerSpine, 0, "scatter_trigger"),
            () => SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.FS_INTRO)]);
        return animTimeLine;
    }

    protected onResize(resizeData: IResizeData): void {
        super.onResize(resizeData);
        this.resizeSAButton();
        if(resizeData.orientation === Orientation.PORTRAIT){
            this._scatterTriggerSpine.position.set(GameConfig.instance.GAME_WIDTH * 0.27 + 10, GameConfig.instance.REEL_AREA_HEIGHT * 0.69);
            this._innerGraphicsContainer.position.set(GameConfig.instance.GAME_WIDTH * 0.27 + 10, GameConfig.instance.REEL_AREA_HEIGHT * 0.71);
        }
        else{
            this._scatterTriggerSpine.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5 + 20, GameConfig.instance.GAME_HEIGHT * 0.53);
            this._innerGraphicsContainer.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5, GameConfig.instance.REEL_AREA_HEIGHT * 0.72);
        }
    }


    public getStartAnimation(prepareToEnterModeCallback:() => void, completeCallback:() => void):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this._button.visible = false;
            this._autoCloseTimer.visible = false;
            this._innerGraphicsContainer.visible = false;
            this._layer.addChild(this);
        });

        tl.add([
            new TweenLite(this._mainGraphicsContainer, 0.5, {alpha : 1, ease : Linear.easeNone})
        ]);
        tl.add(this.playScatterTrigger());
        tl.add(() => prepareToEnterModeCallback(), tl.totalDuration() / 3);
        tl.add(() => {
            this._innerGraphicsContainer.visible = true;
        }, tl.totalDuration() / 1.4);

        tl.add(() => {
            this._button.visible = true;
            this.startTimerAndEnableButton(completeCallback);
        });

        return tl;
    }

    private resizeSAButton():void {
        const buttonSize:PIXI.Point = new PIXI.Point(this.BUTTON_SIZE.x * this._deviceScale, this.BUTTON_SIZE.y * this._deviceScale);
        this._button.setSize(buttonSize.x, buttonSize.y, this._layer.scale.x);
        this._button.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5, GameConfig.instance.REEL_AREA_HEIGHT * 0.92);
    }

    public getEndAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.FS_INTRO_CONTINUE));
        tl.add([
            new TweenLite(this._mainGraphicsContainer, 0.5, {alpha : 0, ease : Linear.easeNone})
        ]);
        tl.add(() => {
            // This will turn off Autoplay if in restricted jurisdiction
            if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
                SlotGame.autoPlay.turnOffAutoplayOnBonus();
            }
            this._layer.removeChild(this);
        });
        return tl;
    }

    public getRestSymbolCallback(restSymbolCallback:() => void):void {
        this._restSymbolCallback = restSymbolCallback;
    }

    private resetSymbols():void {
        if(this._restSymbolCallback) {
            this._restSymbolCallback();
        }
    }

}